/*
 * SideExpertTypeManagement.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 10 2023 mys Company
 */

import { useEffect, useState } from 'react'
import { localization } from '../../config/localize/localizable'

const SidePublishedDate = ({ published = false, className, disabled = false, completion }) => {
    //
    //MARK: VARIABLE
    const [isPublished, setIsPublished] = useState(published)

    //
    //MARK: METHODS

    const handleClick = () => {
        if (disabled) {
            if (completion) completion(!isPublished)
        }
    }

    useEffect(() => {
        if (published !== undefined) setIsPublished(published)
    }, [published])

    return (
        <>
            <div className={`w-full grid grid-cols-4 md:grid-cols-3 bg-white p-2 shadow rounded-md ${className}`}>
                <div className="col-span-3 md:col-span-2 text-sm font-bold mb-1"> {localization.publish}</div>
                <div className={`w-14 border  rounded-full  relative ${isPublished ? 'bg-blue-600' : 'bg-gray-400'}`} onClick={handleClick}>
                    <div className={`w-4 h-4 m-1 rounded-full bg-white relative ${isPublished ? 'right-7' : 'right-0'}`}></div>
                </div>
            </div>
        </>
    )
}

export default SidePublishedDate
